<template>
  <v-card style="height: 120%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 31px;
        font-weight: bold;
        color: #05523e;
        padding-top: 30px;
      "
    >
      Edit Customer
    </v-card-title>
    <div style="margin: 20px 8% auto">
      <div class="rows">
        <span>Company Name</span>
        <v-text-field class="textField" v-model="companyName" outlined />
      </div>
      <div class="rows">
        <span>First Name</span>
        <v-text-field class="textField" v-model="firstName" outlined />
      </div>
      <div class="rows">
        <span>Last Name</span>
        <v-text-field class="textField" v-model="lastName" outlined />
      </div>
      <div class="rows">
        <span>Phone Number</span>
        <v-text-field class="textField" v-model="phoneNumber" outlined />
      </div>
      <div class="rows">
        <span>Address</span>
        <v-text-field class="textField" v-model="address" readonly outlined />
      </div>
      <div class="rows">
        <span></span>
        <v-btn
          @click="openEditAddressModal"
          color="#05523E"
          style="width: 190px; color: white; font-size: 15px"
          >Edit Address</v-btn
        >
      </div>
    </div>
    <div v-if="$store.state.common.editCustomerAddressModalView">
      <v-dialog
        class="rounded-lg"
        v-model="$store.state.common.editCustomerAddressModalView"
        max-width="25%"
      >
        <EditCustomerAddressModalView @getCustomerOne="getCustomerOne" />
      </v-dialog>
    </div>

    <v-card-actions style="justify-content: center">
      <v-btn
        class="action elevation-5"
        color="#ffffff"
        style="
          color: #05523e;
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="$store.commit('common/changeEditCustomerModalView')"
        >Cancle</v-btn
      >
      <v-btn
        class="action white--text elevation-5"
        color="#05523E"
        style="
          max-width: 120px;
          min-width: 100px;
          font-size: 15px;
          font-weight: bold;
          height: 35px;
          margin: 12px;
        "
        @click="editCustomer"
        >Edit</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { runGqlMutation } from "@/graphql/gqlUtil.js";
import { UPDATECUSTOMER } from "@/graphql/AccountMutations.js";
import EditCustomerAddressModalView from "@/components/modal/EditCustomerAddressModal.vue";

export default {
  components: {
    EditCustomerAddressModalView,
  },
  props: ["column", "search", "page_No"],
  data() {
    return {
      custNum: this.$store.state.account.customerOne.custNum,
      companyName: this.$store.state.account.customerOne.company,
      firstName: this.$store.state.account.customerOne.firstName,
      lastName: this.$store.state.account.customerOne.lastName,
      phoneNumber: this.$store.state.account.customerOne.phone,
      address: this.$store.state.account.customerOne.address,
    };
  },
  methods: {
    async editCustomer() {
      try {
        const req = {
          CustNum: this.custNum,
          Company: this.companyName,
          First_Name: this.firstName,
          Last_Name: this.lastName,
          Phone_1: this.phoneNumber,
        };
        const updateResult = await runGqlMutation(UPDATECUSTOMER, req);
        if (
          updateResult.message === undefined &&
          updateResult.updateCustomer.ResultCount.length !== 0
        ) {
          this.$store.commit("common/snackOn", {
            text: "Edit Customer complete.",
          });
          await this.$emit("getCustomers");
        } else {
          this.$store.commit("common/snackErrOn", {
            text: "Edit Customer Failed.",
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async openEditAddressModal() {
      try {
        this.$store.state.account.employeeOne = {};
        this.$store.commit("common/changeEditCustomerAddressModalView");
      } catch (err) {
        console.error(err);
      }
    },
    async getCustomerOne() {
      try {
        await this.$store.dispatch("account/getCustomerOne", {
          Search: this.custNum,
        });
        await this.$emit("getCustomers");
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.rows {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
}
.rows > span {
  width: 185px;
  font-size: 19px;
  font-weight: 500;
}
.textField {
  max-width: 190px;
  min-width: 190px;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  align-items: stretch !important;
  min-height: 0 !important;
}
</style>
